<mat-card class="scorecards-score-summary-card-container">
    <div *ngIf="isDataLoaded && hasData">
        <div class="scorecards-score-info-container">
            <div class="scorecards-score-picture-area">
                <profile-picture
                    [size]="139"
                    [primaryIdentifier]="detailsCard.entityIdentifier"
                    name="{{ detailsCard.entityAbbr }}"
                    *ngIf="detailsCard.scoreCardType === 'employee'"
                >
                </profile-picture>
                <div *ngIf="detailsCard.scoreCardType !== 'employee'">
                    <i class="fas fa-landmark fa-7x profile-icon"></i>
                </div>
            </div>
            <div class="scorecards-score-info-area">
                <div class="info-main-title">
                    {{ detailsCard.entity }}
                </div>
                <div class="info-main-data-area">
                    <div class="info-main-data-area-sub" *ngIf="detailsCard.entityTopLeftValue">
                        <div class="info-main-data-area-sub-title">
                            {{ detailsCard.entityTopLeftTitle }}
                        </div>
                        <div class="info-main-data-area-sub-value">
                            {{ detailsCard.entityTopLeftValue }}
                        </div>
                    </div>
                    <div class="info-main-data-area-sub" *ngIf="detailsCard.entityTopRightValue">
                        <div class="info-main-data-area-sub-title">
                            {{ detailsCard.entityTopRightTitle }}
                        </div>
                        <div class="info-main-data-area-sub-value">
                            {{ detailsCard.entityTopRightValue }}
                        </div>
                    </div>
                    <div class="info-main-data-area-sub" *ngIf="detailsCard.entityBotLeftValue">
                        <div class="info-main-data-area-sub-title">
                            {{ detailsCard.entityBotLeftTitle }}
                        </div>
                        <div class="info-main-data-area-sub-value">
                            {{ detailsCard.entityBotLeftValue }}
                        </div>
                    </div>
                    <div class="info-main-data-area-sub" *ngIf="detailsCard.entityBotRightValue">
                        <div class="info-main-data-area-sub-title">
                            {{ detailsCard.entityBotRightTitle }}
                        </div>
                        <div class="info-main-data-area-sub-value">
                            {{ detailsCard.entityBotRightValue }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="scorecards-score-rank-area">
            <div class="scorecards-score-rank-area-sub">
                <div class="scorecards-score-rank-area-main-title">
                    {{ detailsCard.rankTypeTitle }}
                </div>
                <div class="scorecards-score-rank-data-area">
                    <div class="scorecards-score-rank-data-area-sub data-area-sub-left">
                        <div class="rank-data-area-sub-inner-title">SCORE</div>
                        <div class="rank-data-area-sub-inner-data-area">
                            <div class="rank-data-area-sub-inner-value-main">
                                {{ detailsCard.scoreValue }}
                            </div>
                            <div class="rank-data-area-sub-inner-value-support">
                                <div>out of</div>
                                <div>{{ detailsCard.scoreValueOutOf }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="scorecards-score-rank-data-area-sub data-area-sub-right">
                        <div class="rank-data-area-sub-inner-title">RANK</div>
                        <div class="rank-data-area-sub-inner-data-area">
                            <div class="rank-data-area-sub-inner-value-main">
                                {{ detailsCard.rankValue }}
                            </div>
                            <div class="rank-data-area-sub-inner-value-support">
                                <div>out of</div>
                                <div>{{ detailsCard.rankValueOutOf }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="scorecards-score-rank-area-sub">
                <div class="scorecards-score-rank-area-main-title">
                    {{ detailsCard.productTypeTitle }}
                </div>
                <div class="scorecards-score-rank-data-area">
                    <div class="scorecards-score-rank-data-area-sub data-area-sub-left">
                        <div class="rank-data-area-sub-inner-title">VOL RANK</div>
                        <div class="rank-data-area-sub-inner-data-area">
                            <div class="rank-data-area-sub-inner-value-main">
                                {{ detailsCard.productVolumeValue }}
                            </div>
                            <div class="rank-data-area-sub-inner-value-support">
                                <div>out of</div>
                                <div>{{ detailsCard.productVolumeValueOutOf }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="scorecards-score-rank-data-area-sub data-area-sub-right">
                        <div class="rank-data-area-sub-inner-title">UNIT RANK</div>
                        <div class="rank-data-area-sub-inner-data-area">
                            <div class="rank-data-area-sub-inner-value-main">
                                {{ detailsCard.productUnitsValue }}
                            </div>
                            <div class="rank-data-area-sub-inner-value-support">
                                <div>out of</div>
                                <div>{{ detailsCard.productUnitsValueOutOf }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="row-layout-track scorecards-score-additional-area"
            *ngIf="detailsCard?.bottomCards"
        >
            <div
                *ngFor="let smallCard of detailsCard.bottomCards; let i = index"
                class="small-card-layout-box"
            >
                <small-card class="smallCard-lender" [(smallCardData)]="detailsCard.bottomCards[i]">
                </small-card>
            </div>
        </div>
    </div>

    <div class="scorecards-score-summary-card-spinner">
        <spin-loader *ngIf="!isDataLoaded" [type]="'spinner'"></spin-loader>
    </div>
    <div *ngIf="isDataLoaded && !hasData">
        <no-data-screen [noDataType]="noDataType"></no-data-screen>
    </div>
</mat-card>
